// Recovered compiled webpack factory 93223. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  (Object.defineProperty(t, "__esModule", { value: !0 }),
    !(function (e, t) {
      for (var r in t) Object.defineProperty(e, r, { enumerable: !0, get: t[r] });
    })(t, {
      doesStaticSegmentAppearInURL: function () {
        return u;
      },
      getCacheKeyForDynamicParam: function () {
        return c;
      },
      getParamValueFromCacheKey: function () {
        return d;
      },
      getRenderedPathname: function () {
        return s;
      },
      getRenderedSearch: function () {
        return i;
      },
      parseDynamicParamFromURLPart: function () {
        return l;
      },
      urlToUrlWithoutFlightMarker: function () {
        return f;
      },
    }));
  let n = r(65360),
    a = r(64425),
    o = r(52486);
  function i(e) {
    let t = e.headers.get(o.NEXT_REWRITTEN_QUERY_HEADER);
    return null !== t ? ("" === t ? "" : "?" + t) : f(new URL(e.url)).search;
  }
  function s(e) {
    let t = e.headers.get(o.NEXT_REWRITTEN_PATH_HEADER);
    return null != t ? t : f(new URL(e.url)).pathname;
  }
  function l(e, t, r) {
    switch (e) {
      case "c":
      case "ci":
        return r < t.length ? t.slice(r).map((e) => encodeURIComponent(e)) : [];
      case "oc":
        return r < t.length ? t.slice(r).map((e) => encodeURIComponent(e)) : null;
      case "d":
      case "di":
        if (r >= t.length) return "";
        return encodeURIComponent(t[r]);
      default:
        return "";
    }
  }
  function u(e) {
    return (
      !(
        e === a.ROOT_SEGMENT_REQUEST_KEY ||
        e.startsWith(n.PAGE_SEGMENT_KEY) ||
        ("(" === e[0] && e.endsWith(")"))
      ) &&
      e !== n.DEFAULT_SEGMENT_KEY &&
      "/_not-found" !== e
    );
  }
  function c(e, t) {
    return "string" == typeof e
      ? (0, n.addSearchParamsIfPageSegment)(e, Object.fromEntries(new URLSearchParams(t)))
      : null === e
        ? ""
        : e.join("/");
  }
  function f(e) {
    let t = new URL(e);
    return (t.searchParams.delete(o.NEXT_RSC_UNION_QUERY), t);
  }
  function d(e, t) {
    return "c" === t || "oc" === t ? e.split("/") : e;
  }
  ("function" == typeof t.default || ("object" == typeof t.default && null !== t.default)) &&
    void 0 === t.default.__esModule &&
    (Object.defineProperty(t.default, "__esModule", { value: !0 }),
    Object.assign(t.default, t),
    (e.exports = t.default));
}
